import { useEffect } from "react";

export default function App() {
  useEffect(() => {
    window.location.replace("/presentation.html" + window.location.hash);
  }, []);

  return (
    <div
      data-testid="app-redirect"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, sans-serif",
        color: "#16375A",
      }}
    >
      Loading HepCURE presentation…
    </div>
  );
}
